module.exports = __webpack_public_path__ + "img/mercedes-vito.9a71dbf2.jpeg";